import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Hutang',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Kartu Hutang',
        href: '/adm/fin/laporan/kartu-hutang',
        active: true,
      },
    ],
    form: {
      periode: '',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeHutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getHutang({ commit, state }) {
    commit('changeHutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/hutang`, data.form);
    commit('changeHutang', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
